export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 设备列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    DEVICE_ALL: function DEVICE_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/device/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 设备创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    DEVICE_CREATE: function DEVICE_CREATE(data) {
      return request({
        url: '/api/device/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 设备更新
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_DETAIL: function DEVICE_DETAIL(id) {
      return request({
        url: '/api/device/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 设备更新
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    DEVICE_UPDATE: function DEVICE_UPDATE(data) {
      return request({
        url: '/api/device/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 设备删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    DEVICE_DELETE: function DEVICE_DELETE(id) {
      return request({
        url: '/api/device/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    DEVICE_SYNC: function DEVICE_SYNC(data) {
      return request({
        url: '/api/device/sync',
        method: 'post',
        data: data
      });
    }
  };
});